<template>
    <div class="main-content courses">
        <div v-if="show_tutorial" class="modal-wrapper">
            <div class="modal">
                <div v-if="step==0" class="modal-step-0">
                    <span class="hdl">2 jednoduché kroky</span>
                    <p class="text-mute">Vašu Online spätnú väzbu vyplníte v dvoch jednoduchých krokoch. Všetko ostatné sme už predpripravili za Vás.</p>
                    <div class="steps-info">
                        <div>
                            <span>1</span>
                            <p class="text-mute">V 1. kroku vložíte<br />účastníkov programu</p>
                        </div>
                        <div>
                            <span>2</span>
                            <p class="text-mute">V 2. kroku vytvoríte<br />štruktúru a ich vzťahy</p>
                        </div>
                    </div>
                    <div class="action">
                        <a class="button" @click="nextStep(1)">Ďalej</a>
                    </div>
                </div>
                <div v-if="step==1" class="modal-step-1">
                    <span class="hdl">1.Krok - zoznam účastníkov</span>
                    <p class="text-mute">Účastníkov programu môžete pridať jednotlivo priamym napísaním údajov.</p>

                    <div class="input-tutorial-columns">
                        <div>Email</div>
                        <div>Meno</div>
                        <div>Priezvisko</div>
                    </div>

                    <p class="text-mute m-t-30">alebo jednoduchým nahraním excel tabuľky vo formáte email, meno, priezvisko</p>
                    <div class="input-tutorial-columns">
                        <div>Email</div>
                        <div>Meno</div>
                        <div>Priezvisko</div>
                    </div>
                    <div class="input-tutorial-columns">
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <div class="input-tutorial-columns">
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>

                    <div class="action">
                        <a class="button" @click="nextStep(2)">Prejsť na druhý krok</a>
                    </div>
                </div>
                <div v-if="step==2" class="modal-step-2">
                    <span class="hdl">2.Krok - výber Hodnotených a Hodnotiacich</span>
                    <p class="text-mute">Následne vyberiete hodnoteného (meno môžete vybrať zo zoznamu alebo napísať priamo do poľa)</p>

                    <div class="input-tutorial-columns">
                        <div>Hodnotený</div>
                    </div>

                    <p class="text-mute m-t-30">a priradíte k nemu hodnotiacich podľa vzájomného vzťahu</p>
                    <div class="input-tutorial-columns vert">
                        <div>Nadriadený</div>
                        <div>Podriadený</div>
                        <div>Kolega</div>
                        <div>Iné</div>
                    </div>

                    <div class="action">
                        <a class="button" @click="closeTutorial()">Začať vypĺňať</a>
                    </div>
                </div>
            </div>
        </div>

        <h1>Online spätná väzba</h1>
        <div class="heading-spliter"></div>
        <div class="text-mute">
            Pomocou aplikácie Maxman Survey vám ponúkame možnosť hodnotiť svojich kolegov, prípadne nadriadených,
            podriadených,
            dodávateľov. V prípade akýchkoľvek otázok nás prosím kontaktujte e-mailom na adresu administrátora:
            info@maxman-consultants.com.
        </div>

        <div v-if="!is_company">
            <div v-if="feedbacks && feedbacks.length > 0">
                <h2>Vaše prieskumy</h2>
                <div v-for="feedback in feedbacks">
                    <div class="main-content-box">
                        <div class="left">
                            <h3>{{feedback.name}}</h3>
                            <div class="text-mute">
                                prebiehajúci od {{feedback.course_date_start}} do {{feedback.course_date_end}} |
                                Dokončené:
                                <span class="text-red">{{feedback.feedback_completion_rate}}%</span>
                            </div>
                            <div class="text-mute">
                                Odhadovaný čas vypĺňania:
                                <span class="text-red">{{feedback.question_count}} min</span>
                            </div>
                        </div>
                        <div class="right">
                            <router-link
                                    class="button"
                                    :to="{name: 'feedback_persons', params: {id: feedback.id}}"
                            >Začať >
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <h2>Nemáte priradené žiadne prieskumy</h2>
            </div>
        </div>

        <div v-if="is_company">
            <h2>Pred spustením</h2>
            <div v-for="feedback in feedbacks.prepared">
                <div class="main-content-box">
                    <div class="left">
                        <h3>{{feedback.name}}</h3>
                        <div class="text-mute">
                            Plánovaný začiatok: <span class="text-red">{{feedback.course_date_start}}</span>
                        </div>
                        <div class="text-mute">
                            Plánovaný koniec: <span class="text-red">{{feedback.course_date_end}}</span>
                        </div>
                    </div>
                    <div class="right">
                        <router-link
                                class="button"
                                :to="{name: 'feedback_edit', params: {courseId: feedback.id}}"
                        >Vyplniť >
                        </router-link>
                    </div>
                </div>
            </div>

            <h2>Aktívne</h2>
            <div v-for="feedback in feedbacks.active">
                <div class="main-content-box">
                    <div class="left">
                        <h3>{{feedback.name}}</h3>
                        <div class="text-mute">
                            Dokončené: <span class="text-red">XX%</span>
                        </div>
                        <div class="text-mute">
                            Dátum ukončenia: <span class="text-red">{{feedback.course_date_end}}</span>
                        </div>
                    </div>
                    <div class="right">
                        <router-link
                                class="button outline"
                                :to="{name: 'feedback_edit', params: {courseId: feedback.id}}"
                        >Otvoriť >
                        </router-link>
                    </div>
                </div>
            </div>

            <h2>História</h2>
            <div v-for="feedback in feedbacks.history">
                <div class="main-content-box">
                    <div class="left">
                        <h3>{{feedback.name}}</h3>
                        <div class="text-mute">
                            Dokončené: <span class="text-red">XX%</span>
                        </div>
                    </div>
                    <div class="right">
                        <router-link
                                class="button outline"
                                :to="{name: 'feedback_edit', params: {courseId: feedback.id}}"
                        >Otvoriť >
                        </router-link>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<style lang="css">
.modal-wrapper{
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.7);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
}
.modal{
    position: absolute;
    width: 600px;
    box-sizing: border-box;
    padding: 60px 80px 20px;
    background: #FFF;
    text-align: center;
    left: 50%;
    margin-left: -300px;
    top: 8%;
}
.modal-step-0{
    padding: 0 40px;
}
.modal .hdl{
    font-weight: bold;
    color: #b11116;
    font-size: 16px;
}

.modal .button{
    width: 210px;
    display: inline-block;
    cursor: pointer;
}

.steps-info{
    display: flex;
    margin-top: 20px;
    justify-content: space-between;
}

.steps-info div:first-child span:after{
    content: '';
    width: 150px;
    top: 50%;
    height: 2px;
    background: #b11116;
    position: absolute;
    display: block;
    left: 24px;
}
.steps-info div:last-child span:before{
    content: '';
    width: 150px;
    top: 50%;
    height: 2px;
    background: #b11116;
    position: absolute;
    display: block;
    right: 24px;
}

.steps-info span{
    position: relative;
    font-weight: bold;
    color: #b11116;
    font-size: 18px;
}

.modal .action{
    margin-top: 30px;
}

.input-tutorial-columns{
    display: flex;
    margin-bottom: 2px;
    justify-content: center;
}
.input-tutorial-columns.vert{
    flex-direction: column;
    align-items: center;
}
.input-tutorial-columns.vert div{
    min-width: 136px;
    margin-bottom: 2px;
}
.input-tutorial-columns div{
    flex-grow: 1;
    padding: 5px 10px;
    background: #ebebeb;
    color: #ADADAD;
    margin-right: 3px;
    text-align: left;
    font-size: 12px;
    max-width: 136px;
    min-height: 26px;
}
.input-tutorial-columns div:last-child{
    margin-right:0;
}

</style>

<script>
    export default {
        components: {},
        mixins: [],
        data() {
            return {
                feedbacks: [],
                is_company: this.$api.login.isCompany(),
                show_tutorial: this.$api.login.data.user.show_tutorial && this.$api.login.isCompany(),
                step: 0
            };
        },
        mounted() {
        },
        created() {
            this.refresh();
        },
        methods: {
            nextStep(step){
                this.step = step;
            },
            closeTutorial(){
                this.$api.server.post("api/public/company/seen-tutorial").then((r) => {
                    this.show_tutorial = false;
                });
            },
            refresh() {
                if (this.is_company) {
                    this.$api.server.get("api/public/company/feedbacks?lang_id=" + this.$api.translator.getCurrent()).then(r => {
                        this.feedbacks = r.data.feedbacks;
                    });
                } else {
                    this.$api.server.get("api/public/feedbacks?lang_id=" + this.$api.translator.getCurrent()).then(r => {
                        this.feedbacks = r.data.feedbacks;
                    });
                }
            }
        },
        computed: {},
        watch: {},
        validations() {
        }
    };
</script>



// WEBPACK FOOTER //
// src/public_app/pages/feedback/ListFeedbacks.vue